function Logo() {
  return <span className="pxs-logo-text z-50">RS.</span>;
}

export default Logo;
